<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>改标仓位上架日志</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item>
                  <el-select v-model="form.select_type">
                    <el-option
                      v-for="item in select_type_option"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="form.select_value"></el-input>
                </el-form-item>
                <el-form-item label="操作方式：">
                  <el-select v-model="form.status">
                    <el-option
                      v-for="item in type_option"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="操作时间：">
                  <el-date-picker
                    v-model="form.date"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search(1)">查询</el-button>
                  <el-button type="primary" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="task"
            >导出</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              prop="dbid"
              label="打标id"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              align="center"
              width="300"
            ></el-table-column>
            <el-table-column
              prop="sku"
              label="sku编号"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="co_si_val"
              label="颜色/尺码"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="wave_picking_no"
              label="波次单"
              align="center"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="user_id"
              label="用户id"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="quality_label_summary_id"
              label="汇总单号"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="gb_space"
              label="改标仓位"
              align="center"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="操作方式"
              align="center"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="admin_name"
              label="操作人"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="操作时间"
              align="center"
              width="180"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, sizes, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="size"
            :page-sizes="[50, 100, 200, 500]"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      filterFold: false,
      select_type_option: [
        {
          label: "打标id",
          value: "dbid",
        },
        {
          label: "sku编号",
          value: "sku",
        },
        {
          label: "波次单号",
          value: "wave_picking_no",
        },
        {
          label: "商品名称",
          value: "goods_name",
        },
        {
          label: "用户id",
          value: "user_id",
        },
      ],
      type_option: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "未改标上架",
          value: 1,
        },
        {
          label: "未改标下架",
          value: 2,
        },
        {
          label: "已改标上架",
          value: 3,
        },
        {
          label: "已改标下架",
          value: 4,
        },
      ],
      form: {
        select_type: "",
        select_value: "",
        date: this.defaultDate(),
        status: "",
        p: 1,
        psize: 50,
      },
      curPage: 1,
      size: 50,
      resData: null,
    };
  },
  methods: {
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    search(p = 1) {
      this.form.task = 0;
      this.form.p = p || 1;
      this.curPage = p || 1; // 默认第一页
      this.form.psize = this.size;
      this.$http.post("/erp/GaiBiao/getLog", this.form).then((res) => {
        if (res.data.code == 200) {
          this.resData = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    task() {
      this.form.task = 1;
      this.$http.post("/erp/GaiBiao/getLog", this.form).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("已提交导出任务");
        } else {
          this.$message.error("提交导出任务失败");
        }
      });
    },
    handleCurrentChange(val) {
      this.form.task = 0;
      this.search(val);
    },
    reset() {
      this.form = {
        select_type: "",
        select_value: "",
        status: "",
        date: this.defaultDate(),
        p: 1,
      };
      this.search(1);
    },
    defaultDate() {
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 1);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/GaiBiao/GbLog.vue